<h2>Read number plate</h2>
<mat-card appearance="outlined" *ngIf="call && !isLoading">
  <img [src]="img" alt="image_plaque" />
  <h3>Results</h3>
  <div class="layout-horizontal">
    <ul>
      <li *ngIf="call.textDetected">
        Number plate : <b>{{ call.numberPlate }}</b>
      </li>
      <li *ngIf="!call.textDetected">No text detected</li>
      <li *ngIf="call.textDetected">
        Fiability : <b>{{ call.fiability }}%</b>
      </li>
    </ul>
  </div>
  <div class="question" *ngIf="call.userAnswer == null">
    <p><b>Did it work correctly ?</b></p>
    <button mat-raised-button (click)="onAnswer(true)">YES</button>
    <button mat-raised-button (click)="onAnswer(false)">NO</button>
  </div>
  <div class="question" *ngIf="call.userAnswer != null">
    <p>
      You answered "<b>{{ call.userAnswer ? "yes" : "no" }}</b
      >" to this question.
    </p>
  </div>
</mat-card>
<mat-spinner
  *ngIf="!call || isLoading"
  color="primary"
  diameter="50"
></mat-spinner>
